// bundle-builder.js — v31 (Desktop Fixed)
// Flow: Size → Bedsheet Set (sheet+pillowcases) → Duvet → Extra Sheet Set (optional)
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* --------------------------
       DOM references — Desktop
    ---------------------------*/

    // Key fix: on desktop, bedPreviewDesktop is the active viewer.
    // On mobile, bedPreview is used. We pick based on which is visible.
    function getActiveViewer() {
      const mobile  = document.getElementById('bedPreview');
      const desktop = document.getElementById('bedPreviewDesktop');
      // If desktop viewer exists and is visible (parent not display:none), use it.
      if (desktop && desktop.offsetParent !== null) return desktop;
      // Fallback to mobile viewer
      return mobile || desktop;
    }

    const sizePills       = document.querySelectorAll('.sh-size-pill:not(.sh-extra-size-pill)');
    const extraSizePills  = document.querySelectorAll('.sh-extra-size-pill');
    const tcTabs          = document.querySelectorAll('.sh-tc-tabs');
    const addToCartBtn    = document.getElementById('bundle-add-to-cart');

    const summaryItems    = document.getElementById('summary-items');
    const summarySubtotal = document.getElementById('summary-subtotal');
    const summaryDiscount = document.getElementById('summary-discount');
    const summaryTotal    = document.getElementById('summary-total');
    const summaryList     = document.getElementById('summary-item-list');

    /* --------------------------
       DOM references — Mobile
    ---------------------------*/
    const mobileBarTotal        = document.getElementById('mobileBarTotal');
    const mobileBarCta          = document.getElementById('mobileBarCta');
    const mobileBarDetailsBtn   = document.getElementById('mobileBarDetailsBtn');
    const mobileDrawer          = document.getElementById('mobileDrawer');
    const mobileDrawerClose     = document.getElementById('mobileDrawerClose');
    const mobileDrawerBackdrop  = document.getElementById('mobileDrawerBackdrop');
    const mobileSummaryList     = document.getElementById('mobile-summary-item-list');
    const mobileSummaryItems    = document.getElementById('mobile-summary-items');
    const mobileSummarySubtotal = document.getElementById('mobile-summary-subtotal');
    const mobileSummaryTotal    = document.getElementById('mobile-summary-total');
    const mobileAddToCartBtn    = document.getElementById('mobile-bundle-add-to-cart');

    /* --------------------------
       State
    ---------------------------*/
    const state = {
      size:      'Queen',
      extraSize: 'Queen',
      chosen: {
        bedsheet:          null,
        duvet:             null,
        'extra-bedsheet':  null
      },
      activeTC: {
        bedsheet:          null,
        duvet:             null,
        'extra-bedsheet':  null
      }
    };

    /* --------------------------
       3D model state — one per viewer
    ---------------------------*/
    const viewerState = {
      mobile:  { model: null, ready: false },
      desktop: { model: null, ready: false }
    };

    const MAT = {
      sheet:       'sheet-mat',
      duvet:       'duvet-mat',
      pillow:      'pillow-mat',
      extraSheet:  'sheetx-mat',
      extraPillow: 'pillowx-mat',
      frame:       'Frame-mat'
    };

    /* --------------------------
       Mobile drawer
    ---------------------------*/
    function openMobileDrawer() {
      if (!mobileDrawer) return;
      mobileDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileDrawer() {
      if (!mobileDrawer) return;
      mobileDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    mobileBarDetailsBtn?.addEventListener('click', openMobileDrawer);
    mobileDrawerClose?.addEventListener('click', closeMobileDrawer);
    mobileDrawerBackdrop?.addEventListener('click', closeMobileDrawer);

    /* --------------------------
       Helpers
    ---------------------------*/
    function productCards() {
      return Array.from(document.querySelectorAll('.sh-product-card'));
    }

    function toNumber(v) { return parseFloat(v) || 0; }

    function formatINR(n) {
      return '₹' + Math.round(n).toLocaleString('en-IN');
    }

    function findCard(vid, type) {
      return productCards().find(
        c => c.dataset.variantId === String(vid) && c.dataset.type === type
      );
    }

    function showToast(msg, timeout = 3000) {
      document.querySelectorAll('.sh-toast').forEach(t => t.remove());
      const t = document.createElement('div');
      t.className = 'sh-toast';
      t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(() => { t.style.opacity = '1'; });
      setTimeout(() => {
        t.style.opacity = '0';
        setTimeout(() => t.remove(), 300);
      }, timeout);
    }

    function animateValue(el) {
      if (!el) return;
      el.classList.remove('sh-animate-total');
      void el.offsetWidth;
      el.classList.add('sh-animate-total');
    }

    function mandatorySelected() {
      return !!(state.chosen.bedsheet && state.chosen.duvet);
    }

    function updateCTAText(count) {
      const text = count === 0
        ? 'Add Bundle to Cart'
        : `Add ${count} item${count > 1 ? 's' : ''} to Cart`;

      if (addToCartBtn)       addToCartBtn.textContent       = text;
      if (mobileAddToCartBtn) mobileAddToCartBtn.textContent = text;
      if (mobileBarCta)       mobileBarCta.textContent       = count === 0 ? 'Add to Cart' : `Add ${count} to Cart`;
    }

    /* --------------------------
       3D texture helpers
       Works on any viewer + its cached model
    ---------------------------*/
    async function applyTextureToMaterial(viewer, vState, materialName, texUrl) {
      if (!vState.ready || !texUrl || !viewer) return false;
      try {
        const mat = vState.model.materials.find(m => String(m.name) === String(materialName));
        if (!mat) return false;
        const tex = await viewer.createTexture(texUrl);
        if (!tex) return false;
        mat.pbrMetallicRoughness.baseColorTexture.setTexture(tex);
        return true;
      } catch (err) {
        console.error('[BundleBuilder] texture error', materialName, texUrl, err);
        return false;
      }
    }

    function ensureHiddenMaterial(vState, baseMatName, hiddenMatName) {
      const mats = vState.model.materials;
      if (mats.find(m => m.name === hiddenMatName)) return;
      const baseMat = mats.find(m => m.name === baseMatName);
      if (!baseMat) return;
      const clone = JSON.parse(JSON.stringify(baseMat));
      clone.name = hiddenMatName;
      clone.pbrMetallicRoughness = clone.pbrMetallicRoughness || {};
      clone.pbrMetallicRoughness.baseColorFactor = [1, 1, 1, 0];
      clone.alphaMode = 'BLEND';
      mats.push(clone);
    }

    function hideByMaterial(vState, matName, hidden) {
      const mats  = vState.model.materials;
      const prims = vState.model[Symbol.for('primitives')] || [];
      const hiddenMatName = matName.includes('pillow') ? 'hidden-extraPillow' : 'hidden-extraSheet';
      const matIdxVisible = mats.findIndex(m => m.name === matName);
      const matIdxHidden  = mats.findIndex(m => m.name === hiddenMatName);
      if (matIdxVisible < 0 || matIdxHidden < 0) return;
      prims.forEach(p => {
        if (p.initialMaterialIdx === matIdxVisible || p.activeMaterialIdx === matIdxVisible) {
          p.activeMaterialIdx = hidden ? matIdxHidden : matIdxVisible;
        }
      });
    }

    function colorKeyFromCard(card) {
      if (!card) return null;
      const c = (card.dataset.color || '').trim().toLowerCase();
      if (!c) return null;
      if (TEXTURE_MAP[c]) return c;
      const cDash = c.replace(/\s+/g, '-');
      if (TEXTURE_MAP[cDash]) return cDash;
      for (const key in TEXTURE_MAP) {
        if (key.includes(c) || c.includes(key)) return key;
      }
      return null;
    }

    async function initViewer(viewer, vState) {
      if (!viewer || !viewer.model) return;
      vState.model = viewer.model;
      vState.ready = true;

      ensureHiddenMaterial(vState, MAT.extraSheet,  'hidden-extraSheet');
      ensureHiddenMaterial(vState, MAT.extraPillow, 'hidden-extraPillow');
      hideByMaterial(vState, MAT.extraSheet,  true);
      hideByMaterial(vState, MAT.extraPillow, true);

      const woodUrl = window.BUNDLE_ASSETS?.wood;
      if (woodUrl) await applyTextureToMaterial(viewer, vState, MAT.frame, woodUrl);

      const w = window.BUNDLE_ASSETS?.white;
      if (w) {
        await applyTextureToMaterial(viewer, vState, MAT.sheet,       w);
        await applyTextureToMaterial(viewer, vState, MAT.duvet,        w);
        await applyTextureToMaterial(viewer, vState, MAT.pillow,       w);
        await applyTextureToMaterial(viewer, vState, MAT.extraSheet,   w);
        await applyTextureToMaterial(viewer, vState, MAT.extraPillow,  w);
      }

      await applyCurrentTextures(viewer, vState);
    }

    /* --------------------------
       Core 3D update — applies to ONE viewer
    ---------------------------*/
    async function applyCurrentTextures(viewer, vState) {
      if (!vState.ready || !viewer) return;
      const white = window.BUNDLE_ASSETS?.white;

      const sheetCard = state.chosen.bedsheet
        ? document.querySelector(`[data-variant-id="${state.chosen.bedsheet}"][data-type="bedsheet"]`)
        : null;

      if (sheetCard) {
        const key = colorKeyFromCard(sheetCard);
        if (key) {
          await applyTextureToMaterial(viewer, vState, MAT.sheet,  TEXTURE_MAP[key]);
          await applyTextureToMaterial(viewer, vState, MAT.pillow, TEXTURE_MAP[key]);
        }
      } else if (white) {
        await applyTextureToMaterial(viewer, vState, MAT.sheet,  white);
        await applyTextureToMaterial(viewer, vState, MAT.pillow, white);
      }

      const duvetCard = state.chosen.duvet
        ? document.querySelector(`[data-variant-id="${state.chosen.duvet}"][data-type="duvet"]`)
        : null;

      if (duvetCard) {
        const key = colorKeyFromCard(duvetCard);
        if (key) await applyTextureToMaterial(viewer, vState, MAT.duvet, TEXTURE_MAP[key]);
      } else if (white) {
        await applyTextureToMaterial(viewer, vState, MAT.duvet, white);
      }

      const extraCard = state.chosen['extra-bedsheet']
        ? document.querySelector(`[data-variant-id="${state.chosen['extra-bedsheet']}"][data-type="extra-bedsheet"]`)
        : null;

      if (extraCard && mandatorySelected()) {
        hideByMaterial(vState, MAT.extraSheet,  false);
        hideByMaterial(vState, MAT.extraPillow, false);
        const key = colorKeyFromCard(extraCard);
        if (key) {
          await applyTextureToMaterial(viewer, vState, MAT.extraSheet,  TEXTURE_MAP[key]);
          await applyTextureToMaterial(viewer, vState, MAT.extraPillow, TEXTURE_MAP[key]);
        }
      } else {
        hideByMaterial(vState, MAT.extraSheet,  true);
        hideByMaterial(vState, MAT.extraPillow, true);
        if (white) {
          await applyTextureToMaterial(viewer, vState, MAT.extraSheet,  white);
          await applyTextureToMaterial(viewer, vState, MAT.extraPillow, white);
        }
      }
    }

    // Update ALL ready viewers at once
    async function updatePreview3D() {
      const mobileViewer  = document.getElementById('bedPreview');
      const desktopViewer = document.getElementById('bedPreviewDesktop');
      if (viewerState.mobile.ready  && mobileViewer)  await applyCurrentTextures(mobileViewer,  viewerState.mobile);
      if (viewerState.desktop.ready && desktopViewer) await applyCurrentTextures(desktopViewer, viewerState.desktop);
    }

    /* --------------------------
       Bind model-viewer load events for both viewers
    ---------------------------*/
    function bindViewer(viewerId, vState) {
      const v = document.getElementById(viewerId);
      if (!v) return;
      const onLoad = () => initViewer(v, vState);
      v.addEventListener('load', onLoad);
      if (v.model) setTimeout(onLoad, 200);
    }

    bindViewer('bedPreview',        viewerState.mobile);
    bindViewer('bedPreviewDesktop', viewerState.desktop);

    /* --------------------------
       Build item rows (shared desktop + mobile)
    ---------------------------*/
    function buildItemRows(items, containerEl, onRemove) {
      containerEl.innerHTML = '';
      if (items.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'sh-summary-empty';
        empty.textContent = 'No items selected yet';
        containerEl.appendChild(empty);
        return;
      }
      items.forEach(item => {
        const row = document.createElement('div');
        row.className = 'sh-summary-item';
        row.innerHTML = `
          <img src="${item.image}" class="sh-summary-thumb" alt="${item.title}" />
          <div class="sh-summary-item-info">
            <div class="sh-summary-item-title">${item.title}</div>
            <div class="sh-summary-item-meta">${item.meta}</div>
          </div>
          <div class="sh-summary-item-actions">
            <span>${formatINR(item.price)}</span>
            <button class="sh-remove-item" data-type="${item.type}" title="Remove">✕</button>
          </div>
        `;
        containerEl.appendChild(row);
      });
      containerEl.querySelectorAll('.sh-remove-item').forEach(btn => {
        btn.addEventListener('click', () => onRemove(btn.dataset.type));
      });
    }

    /* --------------------------
       Summary update
    ---------------------------*/
    function updateSummary() {
      const items = [];

      Object.keys(state.chosen).forEach(type => {
        const vid = state.chosen[type];
        if (!vid) return;
        const el = findCard(vid, type);
        if (!el) return;
        items.push({
          type,
          id:    vid,
          price: toNumber(el.dataset.price),
          title: el.querySelector('.sh-card-title')?.textContent || '',
          image: el.dataset.image,
          meta:  `${el.dataset.size} · ${el.dataset.tc} TC`
        });
      });

      const subtotal  = items.reduce((s, i) => s + i.price, 0);
      const count     = items.length;
      const isEnabled = count > 0;

      // Desktop
      if (summaryItems)    summaryItems.textContent    = count;
      if (summarySubtotal) summarySubtotal.textContent = formatINR(subtotal);
      if (summaryDiscount) summaryDiscount.textContent = '—';
      if (summaryTotal)    summaryTotal.textContent    = formatINR(subtotal);
      if (summaryList)     buildItemRows(items, summaryList, t => setChosen(t, null));
      animateValue(summaryTotal);
      if (addToCartBtn) addToCartBtn.disabled = !isEnabled;

      // Mobile drawer
      if (mobileSummaryItems)    mobileSummaryItems.textContent    = count;
      if (mobileSummarySubtotal) mobileSummarySubtotal.textContent = formatINR(subtotal);
      if (mobileSummaryTotal)    mobileSummaryTotal.textContent    = formatINR(subtotal);
      if (mobileSummaryList)     buildItemRows(items, mobileSummaryList, t => setChosen(t, null));
      if (mobileAddToCartBtn)    mobileAddToCartBtn.disabled       = !isEnabled;

      // Mobile sticky bar
      if (mobileBarTotal) {
        mobileBarTotal.textContent = formatINR(subtotal);
        animateValue(mobileBarTotal);
      }
      if (mobileBarCta) mobileBarCta.disabled = !isEnabled;

      updateCTAText(count);
      updateAddButtonTextAll();
      updatePreview3D();
    }

    /* --------------------------
       Selection
    ---------------------------*/
    function updateAddButtonTextAll() {
      productCards().forEach(card => {
        const btn      = card.querySelector('.sh-add-btn');
        const type     = card.dataset.type;
        const isChosen = state.chosen[type] && String(state.chosen[type]) === String(card.dataset.variantId);
        if (btn) btn.textContent = isChosen ? 'Remove' : 'Add';
        card.setAttribute('aria-pressed', isChosen ? 'true' : 'false');
      });
    }

    function setChosen(type, vid) {
      productCards().forEach(c => {
        if (c.dataset.type === type) c.setAttribute('aria-pressed', 'false');
      });

      state.chosen[type] = vid ? String(vid) : null;

      if (vid) {
        const el = findCard(vid, type);
        if (el) el.setAttribute('aria-pressed', 'true');
      }

      if (type === 'extra-bedsheet' && !mandatorySelected() && state.chosen[type]) {
        state.chosen[type] = null;
        showToast('Please select a bedsheet set and duvet cover first.');
        updateAddButtonTextAll();
        return;
      }

      updateSummary();
    }

    /* --------------------------
       Filtering
    ---------------------------*/
    function filterAllGrids() {
      productCards().forEach(card => {
        const type = card.dataset.type;
        let visible = true;

        if (type === 'bedsheet') {
          if (card.dataset.size && card.dataset.size.toLowerCase() !== state.size.toLowerCase()) {
            visible = false;
          }
        }

        if (type === 'extra-bedsheet') {
          if (card.dataset.size && card.dataset.size.toLowerCase() !== state.extraSize.toLowerCase()) {
            visible = false;
          }
        }

        const activeTc = state.activeTC[type];
        if (activeTc && card.dataset.tc !== activeTc) {
          visible = false;
        }

        card.style.display = visible ? '' : 'none';
      });
    }

    function initActiveTCs() {
      tcTabs.forEach(tab => {
        const block     = tab.dataset.for;
        const firstPill = tab.querySelector('.sh-tc-pill');
        if (firstPill && !state.activeTC[block]) {
          state.activeTC[block] = firstPill.dataset.tc;
        }
      });
    }

    function validateSelectionsAfterFilter() {
      Object.keys(state.chosen).forEach(type => {
        const vid = state.chosen[type];
        if (!vid) return;
        const card = findCard(vid, type);
        if (!card || card.style.display === 'none') {
          setChosen(type, null);
        }
      });
    }

    /* --------------------------
       Event listeners
    ---------------------------*/
    sizePills.forEach(p => {
      p.addEventListener('click', () => {
        state.size = p.dataset.size;
        sizePills.forEach(x => {
          x.classList.toggle('sh-tc-active', x.dataset.size === state.size);
          x.classList.toggle('sh-active',    x.dataset.size === state.size);
        });
        filterAllGrids();
        validateSelectionsAfterFilter();
        updateSummary();
      });
    });

    extraSizePills.forEach(p => {
      p.addEventListener('click', () => {
        state.extraSize = p.dataset.size;
        extraSizePills.forEach(x => {
          x.classList.toggle('sh-tc-active', x.dataset.size === state.extraSize);
          x.classList.toggle('sh-active',    x.dataset.size === state.extraSize);
        });
        filterAllGrids();
        validateSelectionsAfterFilter();
        updateSummary();
      });
    });

    tcTabs.forEach(tab => {
      tab.querySelectorAll('.sh-tc-pill').forEach(btn => {
        btn.addEventListener('click', () => {
          const block = tab.dataset.for;
          state.activeTC[block] = btn.dataset.tc;
          tab.querySelectorAll('.sh-tc-pill').forEach(b => {
            b.classList.toggle('sh-tc-active', b.dataset.tc === btn.dataset.tc);
          });
          filterAllGrids();
          validateSelectionsAfterFilter();
          updateSummary();
        });
      });
    });

    function bindCards() {
      productCards().forEach(card => {
        card.addEventListener('click', e => {
          if (e.target.closest('.sh-add-btn')) return;
          handleCardToggle(card);
        });
        const btn = card.querySelector('.sh-add-btn');
        btn?.addEventListener('click', e => {
          e.stopPropagation();
          handleCardToggle(card);
        });
      });
    }

    function handleCardToggle(card) {
      const type = card.dataset.type;
      const vid  = card.dataset.variantId;

      if (type === 'extra-bedsheet' && !mandatorySelected()) {
        showToast('Please select a bedsheet set and duvet cover first.');
        return;
      }

      if (state.chosen[type] === vid) {
        setChosen(type, null);
      } else {
        setChosen(type, vid);
      }
    }

    bindCards();

    /* --------------------------
       Add to cart
    ---------------------------*/
    async function addBundleToCart() {
      if (!mandatorySelected()) {
        showToast('Please choose a bedsheet set and duvet cover before adding to cart.');
        return;
      }

      const items = [];
      Object.keys(state.chosen).forEach(t => {
        const vid = state.chosen[t];
        if (vid) items.push({ id: Number(vid), quantity: 1 });
      });

      [addToCartBtn, mobileAddToCartBtn, mobileBarCta].forEach(btn => {
        if (btn) btn.disabled = true;
      });

      const prevDesktopText = addToCartBtn?.textContent;
      const prevMobileText  = mobileAddToCartBtn?.textContent;
      if (addToCartBtn)       addToCartBtn.textContent       = 'Adding…';
      if (mobileAddToCartBtn) mobileAddToCartBtn.textContent = 'Adding…';
      if (mobileBarCta)       mobileBarCta.textContent       = 'Adding…';

      try {
        const resp = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items })
        });

        if (!resp.ok) {
          let err;
          try { err = await resp.json(); } catch (e) { err = { description: 'Could not add items to cart.' }; }
          showToast(`Failed: ${err?.description || 'Unknown error'}`);
          console.error('[BundleBuilder] add failed', err);
        } else {
          try {
            const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r => r.json());
            updateCartCountUI(cart.item_count);
          } catch (e) {
            console.warn('[BundleBuilder] Could not fetch cart count', e);
          }

          showToast('Bundle added to cart! 🎉');
          closeMobileDrawer();

          [addToCartBtn, mobileAddToCartBtn, mobileBarCta].forEach(btn => {
            if (btn) {
              btn.classList.add('sh-success');
              btn.textContent = 'Added ✓';
            }
          });

          setTimeout(() => {
            [addToCartBtn, mobileAddToCartBtn, mobileBarCta].forEach(btn => {
              if (btn) {
                btn.classList.remove('sh-success');
                btn.disabled = false;
              }
            });
            if (addToCartBtn)       addToCartBtn.textContent       = prevDesktopText;
            if (mobileAddToCartBtn) mobileAddToCartBtn.textContent = prevMobileText;
            if (mobileBarCta)       mobileBarCta.textContent       = 'Add to Cart';
          }, 1800);

          return;
        }
      } catch (err) {
        console.error('[BundleBuilder] network error', err);
        showToast('Network error. Please try again.');
      } finally {
        [addToCartBtn, mobileAddToCartBtn, mobileBarCta].forEach(btn => {
          if (btn) btn.disabled = false;
        });
      }
    }

    function updateCartCountUI(count) {
      if (typeof count === 'undefined') return;
      const selectors = [
        '[data-cart-count]', '.js-cart-count', '.cart-count',
        '.site-header__cart-count', '#CartCount', '.cart-badge', '.header-cart-count'
      ];
      selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => { el.textContent = count; });
      });
    }

    addToCartBtn?.addEventListener('click', addBundleToCart);
    mobileAddToCartBtn?.addEventListener('click', addBundleToCart);
    mobileBarCta?.addEventListener('click', addBundleToCart);

    /* --------------------------
       Carousel dot indicators
    ---------------------------*/
    function initCarouselDots(gridId, dotsId) {
      const grid = document.getElementById(gridId);
      const dotsContainer = document.getElementById(dotsId);
      if (!grid || !dotsContainer) return;

      function getVisibleCards() {
        return Array.from(grid.children).filter(c => c.style.display !== 'none');
      }

      function buildDots() {
        const cards = getVisibleCards();
        dotsContainer.innerHTML = '';
        if (cards.length <= 1) return;
        cards.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.className = 'sh-carousel-dot' + (i === 0 ? ' sh-dot-active' : '');
          dot.setAttribute('aria-label', 'Go to product ' + (i + 1));
          dot.addEventListener('click', () => {
            cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          });
          dotsContainer.appendChild(dot);
        });
      }

      function updateActiveDot() {
        const cards = getVisibleCards();
        const dots = dotsContainer.querySelectorAll('.sh-carousel-dot');
        if (!cards.length || !dots.length) return;
        const scrollLeft = grid.scrollLeft;
        let closestIdx = 0;
        let closestDist = Infinity;
        cards.forEach((card, i) => {
          const dist = Math.abs(card.offsetLeft - scrollLeft);
          if (dist < closestDist) { closestDist = dist; closestIdx = i; }
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('sh-dot-active', i === closestIdx);
        });
      }

      buildDots();
      grid.addEventListener('scroll', updateActiveDot, { passive: true });

      const observer = new MutationObserver(() => {
        buildDots();
        updateActiveDot();
      });
      observer.observe(grid, { childList: false, subtree: true, attributeFilter: ['style'] });
    }

    /* --------------------------
       Init
    ---------------------------*/
    function init() {
      initActiveTCs();
      filterAllGrids();
      updateAddButtonTextAll();
      updateSummary();
      initCarouselDots('grid-bedsheet',       'dots-bedsheet');
      initCarouselDots('grid-duvet',          'dots-duvet');
      initCarouselDots('grid-extra-bedsheet', 'dots-extra-bedsheet');
    }

    init();
  });
})();